import { OnInit, Component, Input, NgZone } from "@angular/core";
import { MainPageService } from "../../main-page.service";
import { StpConfigureService } from "../stp-configure.service";
import { ShowViewerArgs } from "../../../models/viewer/ShowViewerArgs.model";
import { PipeRingVariantConfigModel } from "../../../models/parts/pipering-variant-config.model";

@Component({
    selector: 'threaded-configure',
    template: `<div class="arms-table">
    <span>Threaded rods:</span>
    <div class="display-flex">
        <select name="groupSelect" style="width: 80%;" [(ngModel)]="currentChoosenThreadeRod" (change)="onGroupChange($event)">
            <option *ngFor="let threadedRod of piperingVariantConfig.threadedRods" [ngValue]="threadedRod.id" selected="threadedRod.id===currentChoosenThreadeRod">{{threadedRod.channelName}}</option>
        </select>
        <div style="padding-left: 20px;">
            <i class="material-icons icon-button" data-toggle="modal" data-target=".addModal" (click)="selectedOption = channelOptions[0]">
                add_circle
            </i>
            <i class="material-icons icon-button" data-toggle="modal" data-target=".confirmationModal">
                remove_circle
            </i>
        </div>
    </div>
    <div class="h-auto-scroll" *ngIf="piperingVariantConfig.threadedRods[0]!==undefined">
        <div class="h-100" >
            <table>
                <colgroup>
                    <col span="1" style="width: 100%;">
                </colgroup>
                <thead>
                    <tr>
                        <th>Connectors</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="armHeaderLabel">
                                <i class="material-icons icon-button add-profile-btn" (click)="addConnector()">
                                    add_circle
                                </i>
                            </div>
                            <table>
                                <colgroup>
                                    <col span="1" style="width: 10%;">
                                    <col span="1" style="width: 30%;">
                                    <col span="1" style="width: 20%;">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Connector name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let connector of piperingVariantConfig.threadedRods[currentChoosenThreadeRod - 1].connectors">
                                        <td>
                                            <i class="material-icons icon-button clickable" [hidden]="connector.isShown">
                                                visibility_off
                                            </i>
                                            <i class="material-icons icon-button clickable" [hidden]="!connector.isShown">
                                                visibility
                                            </i>
                                        </td>
                                        <td>
                                            <ng-select [items]="connectorOptions" [active]="activeConnector(connector)" (selected)="connectorChanged(connector, $event)"></ng-select>
                                        </td>
                                        <td>
                                            <i class="material-icons icon-button" (click)="removeConnector(connector)">
                                                remove_circle
                                            </i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<!-- Add Modal -->
<div class="modal addModal" id="addModal" #addModal>
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Channel: &nbsp;</span>
                    <!-- <input type="text" #newRodName> -->
                    <select  [(ngModel)]="selectedOption">
                        <option *ngFor="let channel of channelOptions" [ngValue]="channel">{{channel.name}}</option>
                    </select>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="addNewThreadedRod()">Save</button>
            </div>

        </div>
    </div>
</div>

<!-- Confiramtion Modal -->
<div class="modal confirmationModal" id="confirmationModal" #confirmationModal>
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div>
                    Do you want to remove current rod?
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="removeCurrentThreadedRod()">Remove</button>
            </div>
        </div>
    </div>
</div>`,
    styles: [`.armHeaderLabel{text-align:left;margin-left:6px;font-size:16px!important;height:32px;display:flex;align-items:center;position:relative}.add-profile-btn{position:absolute;right:10px}.clickable{cursor:pointer}.buttonTransparent{padding:0;background-color:transparent;border:none}.buttonTransparent:disabled{opacity:.2}.inner-table{display:block;overflow-y:auto;overflow-x:hidden}.h-auto-scroll{overflow-y:auto;height:calc(100% - 65px)}`, `table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:1px}tr:nth-child(even){background-color:#ddd}.icon-button{cursor:pointer;font-size:30px;vertical-align:middle}.icon-button .close-icon{cursor:pointer;position:absolute;right:10px}.steps{display:flex;list-style:none;align-items:center;margin:0;height:60px;padding:0;justify-content:space-between}.btnStep{color:#000;font-weight:700;font-size:14px;letter-spacing:.5px;background-color:transparent;border:0;outline:0}.btnStep:disabled{opacity:.6!important;cursor:default}.step::before{background-color:#ccc9cc;margin-left:16px;min-width:70%;height:2px}.step:nth-child(1) .btnStep::before{content:"1"}.step:nth-child(2) .btnStep::before{content:"2"}.step:nth-child(3) .btnStep::before{content:"3"}.step:nth-child(4) .btnStep::before{content:"4"}.step:nth-child(5) .btnStep::before{content:"5"}.step:nth-child(6) .btnStep::before{content:"6"}.btnStep::before{display:inline-block;width:40px;min-width:40px;height:40px;border:0;border-radius:50%;right:0;background-color:#000;margin-right:12px;text-align:center;color:#fff;line-height:40px;font-size:13px}.arms-table{bottom:41px;right:18px;height:100%;background-color:#fff}.arms-table td,.arms-table th{text-align:center}.red-button{font-family:inherit;padding:7px 14px}.currentTab::before{background-color:#d0021b!important}.display-flex{display:flex;margin-bottom:10px}`]
})

export class ThreadedConfigureComponent implements OnInit {
    @Input() args: ShowViewerArgs = {
        variantId: "31",
        show: true,
        itemType: "PIPE_RING",
        itemId: "31",
        subType: null
    };
    private pipering: any[];
    public connectorOptions: any[];
    public channelOptions: any[];
    public currentChoosenThreadeRod: number = 1;
    public piperingVariantConfig: any;
    public selectedOption: any;

    @Input() set Args(value: ShowViewerArgs) {
        this.args = value;
        if (this.args !== null) {
            this.loadVariantData();
        }
    }

    constructor(private mainPageService: MainPageService,
        private stpConfigureService: StpConfigureService,
        private zone: NgZone
    ) {
        this.piperingVariantConfig = { threadedRods: [{ connectors: [] }] };
    }

    ngOnInit(): void {
        this.connectorOptions = [];
        this.loadVariantData();
        this.mainPageService.loadAllConnectors().subscribe((allConnectors) => {
            this.connectorOptions.splice(0, this.connectorOptions.length); // clear array
            for (var j = 0; j < allConnectors.length; j++) {
                var connector = allConnectors[j];
                this.connectorOptions.push({ id: connector._id, text: connector.name });
            }
        });
        this.mainPageService.loadAllChannels().subscribe((allChannels) => {
            this.channelOptions = allChannels;
        })
    }

    loadVariantData(): void {
        this.mainPageService.getPiperingVariantConfigurationData(this.args.variantId).subscribe((response) => {
            if ((response.isEmpty !== undefined) ? response.isEmpty : false) {
                this.createNewConfig();
            } else {
                this.piperingVariantConfig = response;
            }
        });
    }

    createNewConfig() {
        this.mainPageService.getSpecificPipering(this.args.itemId).subscribe((res) => {
            this.pipering = res;
            this.piperingVariantConfig = new PipeRingVariantConfigModel();
            this.piperingVariantConfig._id = this.args.variantId;
            this.piperingVariantConfig.isStandard = !(this.pipering[0].piperingGroupId === 2 || this.pipering[0].piperingGroupId === 3);
            if (this.piperingVariantConfig.isStandard) {
                this.piperingVariantConfig.isCeiling = true;
            }
            this.piperingVariantConfig.isDouble = false;
        });

    }

    saveVariantChanges() {
        this.mainPageService.postPiperingVariantConfiguration(this.piperingVariantConfig).subscribe((response) => { });
    }

    addConnector() {

        const emptyConnector = {
            id: (this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors !== undefined) ?
                this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors.length : 0,
            connectorId: null,
            connectorName: null,
            isShown: false,
        }
        this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors.push(emptyConnector);
        this.saveVariantChanges();
    }

    removeConnector(connector) {
        let newConnectors: any[] = [];
        for (let j = 0; j < this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors.length; j++) {
            const curConnector = this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors[j];
            if (curConnector !== connector) {
                const newThreadedRod = {
                    id: newConnectors.length + 1,
                    connectorId: curConnector.connectorId,
                    connectorName: curConnector.connectorName,
                    isShown: curConnector.isShown,
                };
                newConnectors.push(newThreadedRod);
            }
        }
        this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors = newConnectors;
        this.saveVariantChanges();
    }

    connectorChanged(connector, event) {
        const ind = this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors.indexOf(connector);
        this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors[ind].connectorId = event.id;
        this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1].connectors[ind].connectorName = event.text;
        this.saveVariantChanges();
    }

    // showConnector(arm, connector) {
    //     this.extensionInterface.changeShownconnector(arm, connector, this.currentChoosenThreadeRod);
    // }

    // hideConnectors() {
    //     this.extensionInterface.hideConnectorconnectors();
    // }

    addNewThreadedRod() {
        const emptyRod = {
            id: this.piperingVariantConfig.threadedRods.length + 1,
            channelId: this.selectedOption._id,
            channelName: this.selectedOption.name,
            connectors: [],
        }
        this.piperingVariantConfig.threadedRods.push(emptyRod);
        this.currentChoosenThreadeRod = this.piperingVariantConfig.threadedRods.length;
        this.saveVariantChanges();
    }

    removeCurrentThreadedRod() {
        let newThreadedRods: any[] = [];
        for (let j = 0; j < this.piperingVariantConfig.threadedRods.length; j++) {
            const curThreadedRod = this.piperingVariantConfig.threadedRods[j];
            if (curThreadedRod.id !== this.currentChoosenThreadeRod) {
                const newThreadedRod = {
                    id: newThreadedRods.length + 1,
                    _id: curThreadedRod.threadedRodName._id,
                    threadedRodName: curThreadedRod.threadedRodName,
                    connectors: curThreadedRod.connectors,
                }
                newThreadedRods.push(newThreadedRod);
            }
        }
        this.piperingVariantConfig.threadedRods = newThreadedRods;
        this.saveVariantChanges();
        if (this.piperingVariantConfig.threadedRods[this.currentChoosenThreadeRod - 1] === undefined) {
            this.currentChoosenThreadeRod = this.currentChoosenThreadeRod - 1;
        }
    }

    onGroupChange(event) {
        // this.showProfilesConfiguration();
    }

    activeConnector(connector) {
        const activeConnector = {
            id: connector.connectorId,
            text: connector.connectorName
        };
        const array = [];
        array.push(activeConnector);
        if (activeConnector.id !== null && activeConnector.text !== null) {
            return array;
        }
    }
}
